(() => {
  if (window.__zwiftPlyrInitLoaded) return;
  window.__zwiftPlyrInitLoaded = true;

  const PLYR_OPTIONS = {
    controls: ['play-large', 'play', 'progress', 'mute', 'volume', 'fullscreen'],
    hideControls: false,
    clickToPlay: true,
    youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
    vimeo: { byline: false, portrait: false, title: false, transparent: false },
  };

  const CUSTOM_PLAY_SVG = '<svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg>';

  function applyCustomPlayIconTo(host) {
    const overlay = host.querySelector('.plyr__control--overlaid');
    if (!overlay) return false;
    const existingSvg = overlay.querySelector('svg');
    if (!existingSvg) return false;
    existingSvg.outerHTML = CUSTOM_PLAY_SVG;
    return true;
  }

  function initPlyrOn(host) {
    if (host.dataset.plyrInitialized === 'true') return;
    if (typeof window.Plyr === 'undefined') return;
    const media = host.querySelector('video, iframe');
    if (!media) return;
    host.dataset.plyrInitialized = 'true';
    new window.Plyr(media, PLYR_OPTIONS);
    if (!applyCustomPlayIconTo(host)) {
      requestAnimationFrame(() => applyCustomPlayIconTo(host));
    }
  }

  function tryInitAll(root = document) {
    root.querySelectorAll('[data-plyr-target]').forEach((host) => {
      if (host.getAttribute('data-media-loaded') === 'true' || host.querySelector('video, iframe')) {
        initPlyrOn(host);
      }
    });
  }

  const attributeObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.attributeName !== 'data-media-loaded') continue;
      const target = m.target;
      if (target instanceof HTMLElement && target.hasAttribute('data-plyr-target') && target.getAttribute('data-media-loaded') === 'true') {
        initPlyrOn(target);
      }
    }
  });

  function observeExistingTargets(root = document) {
    root.querySelectorAll('[data-plyr-target]').forEach((host) => {
      attributeObserver.observe(host, { attributes: true, attributeFilter: ['data-media-loaded'] });
    });
  }

  function startWatchingHost(host) {
    attributeObserver.observe(host, { attributes: true, attributeFilter: ['data-media-loaded'] });
    initPlyrOn(host);
  }

  const insertionObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.('[data-plyr-target]')) startWatchingHost(node);
        node.querySelectorAll?.('[data-plyr-target]').forEach(startWatchingHost);
      });
    }
  });

  function boot() {
    observeExistingTargets();
    tryInitAll();
    insertionObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
